// Advance only forward when a card leaves the list
export const nextOpenCardId = (
  cardIds: readonly string[],
  leavingId: string
): string | undefined => {
  const index = cardIds.indexOf(leavingId);
  if (index < 0) return undefined;
  return cardIds[index + 1];
};
